import GenericViewOffline from '../GenericViewOffline';

export default class passenger_stats extends GenericViewOffline {
    constructor(uri, app, className, data) {
        super(uri, app, (className || 'passenger_stats'), data);
        this.auto_destroy = true;
    }
}
